var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { fontFamily, fontWeight } from "core/styles/snippets";
var Title = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.variant, variant = _b === void 0 ? "medium" : _b, props = __rest(_a, ["children", "className", "variant"]);
    return (React.createElement(TitleStyled, { variant: variant, className: className, "data-component": props["data-component"] }, children));
};
export default Title;
var variantToTypo = function (variant) {
    switch (variant) {
        case "small":
            return "font-size: 1.5rem; line-height: 1.5;";
        case "medium":
            return "font-size: 2rem; line-height: 1.3125;";
        case "large":
            return "font-size: 2.5rem; line-height: 1.2; ".concat(fontWeight.extraBold);
    }
};
var TitleStyled = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  margin: 0;\n  ", ";\n  ", ";\n"], ["\n  display: block;\n  width: 100%;\n  margin: 0;\n  ", ";\n  ", ";\n"])), fontFamily.title, function (props) { return variantToTypo(props.variant); });
var templateObject_1;
